export default ({request}) => ({
    ecomHxPlatformListApi(data = {}) {
      return request({
        url: '/ecom/hx/platform/list',
        method: 'post',
        data,
      })
    },
    ecomHxPlatformDetailApi(data = {}) {
      return request({
        url: '/ecom/hx/platform/detail',
        method: 'post',
        data,
      })
    },
    ecomHxPlatformSaveApi(data = {}) {
      return request({
        url: '/ecom/hx/platform/save',
        method: 'post',
        data,
      })
    },
    ecomHxPlatformDelApi(data = {}) {
      return request({
        url: '/ecom/hx/platform/del',
        method: 'post',
        data,
      })
    },
  })
  